export default {

    LOAD_EMPLOYEES(state, employees) {
        state.items = employees;
    }

}